/* eslint-disable */
// https://stackoverflow.com/a/65239086/10321531
import colors from '../constants/colorDB'

export const mapCharsToColor = (str = '') => {
  let hash = 0
  for (let i = 0; i < str.length; ++i)
    hash = Math.imul(31, hash) + str.charCodeAt(i)

  hash = Math.abs(hash | 0)

  return colors[hash % colors.length]
}
